import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

// Public pages
import SignInPage from "../pages/Auth/SignInPage";
import SignUpPage from "../pages/Auth/SignUpPage";
import ForgotPasswordPage from "../pages/Auth/ForgotPasswordPage";
import ResetPasswordPage from "../pages/Auth/ResetPasswordPage"


import Dashboard from "../pages/components/Dashboard";
import Enrichment from "../pages/components/Enrichment";
import NewData from "../pages/components/NewData";
import MyAccount from "../pages/components/MyAccount";
import ReferAndEarn from "../pages/components/ReferAndEarn";
// import Feedback from "../pages/components/Feedback";

// Errors
import NotFoundPage from "../pages/Error/NotFoundPage";
import AccessDeniedPage from "../pages/Error/AccessDeniedPage";

// Layout
import Navbar from "../components/Layout/Navbar";

// App pages
import EmailVerification from "../pages/components/EmailVerification";
import ProtectedRoute from "./ProtectedRoute";


const AppRoutes: React.FC = () => {
  return (
    <Routes>
      {/* 🔓 Public */}
      <Route path="/" element={<SignInPage />} />
      <Route path="/signin" element={<SignInPage />} />
      <Route path="/register" element={<SignUpPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />      
      <Route path="/reset-password" element={<ResetPasswordPage />} />      

      {/* 🔐 Protected Layout */}
      <Route element={<Navbar />}>
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      </Route>
      {/* 🔐 Protected Layout */}
      <Route element={<Navbar />}>
        <Route path="/email-verification" element={<ProtectedRoute><EmailVerification /></ProtectedRoute>} />
      </Route>
      {/* 🔐 Protected Layout */}
      <Route element={<Navbar />}>
        <Route path="/enrichment" element={<ProtectedRoute><Enrichment /></ProtectedRoute>} />
      </Route>
      {/* 🔐 Protected Layout */}
      <Route element={<Navbar />}>
        <Route path="/new-data" element={<ProtectedRoute><NewData /></ProtectedRoute>} />
      </Route>

      {/* 🔐 Protected Layout */}
      <Route element={<Navbar />}>
        <Route path="/my-account" element={<ProtectedRoute><MyAccount /></ProtectedRoute>} />
      </Route>

      <Route element={<Navbar />}>
        <Route path="/refer-earn" element={<ProtectedRoute><ReferAndEarn /></ProtectedRoute>} />
      </Route>
   
      {/* <Route element={<Navbar />}>
        <Route path="/feedback" element={<ProtectedRoute><Feedback /></ProtectedRoute>} />
      </Route> */}

      <Route path="/access-denied" element={<AccessDeniedPage />} />
      <Route path="/404" element={<NotFoundPage />} />
      <Route path="/" element={<NotFoundPage />} />

      <Route path="/" element={<Navigate to="/signin" replace />} />
    </Routes>
  );
};

export default AppRoutes;
